import { LegalPage } from "../components/site/LegalPage";

const S = [
  ["1. आम्ही कोणती माहिती घेतो · Information we collect", <>
    <p>नोंदणी करताना तुमचे नाव, मोबाईल नंबर, जिल्हा व तालुका; जाहिरात टाकताना फोटो, वर्णन, किंमत व ठिकाण.</p>
    <p>We store your name, mobile number, district/taluka, your ads and photos, and basic technical data (device/browser) needed to run the site.</p>
  </>],
  ["2. माहितीचा वापर · How we use it", <>
    <p>तुमचे खाते चालवण्यासाठी, जाहिराती दाखवण्यासाठी, Membership तपासण्यासाठी आणि Spam/फसवणूक रोखण्यासाठी.</p>
    <p>We never sell your personal data. Your mobile number is shown only to logged-in members with an active plan, so buyers and sellers can contact each other directly.</p>
  </>],
  ["3. PIN व सुरक्षा · Security", <p>तुमचा 4 अंकी PIN encrypted (hashed) स्वरूपात साठवला जातो. कोणीही - आमचे कर्मचारीसुद्धा - तो पाहू शकत नाही. आम्ही कधीही OTP किंवा PIN फोनवर विचारत नाही.</p>],
  ["4. Payment", <p>Membership payment PhonePe / Google Pay / UPI किंवा भविष्यात Razorpay द्वारे होते. आम्ही तुमच्या Card/Bank चे तपशील साठवत नाही.</p>],
  ["5. माहिती हटवणे · Deleting your data", <p>तुम्ही "My Account" मधून तुमच्या जाहिराती कधीही हटवू शकता. खाते पूर्णपणे हटवण्यासाठी आम्हाला ईमेल करा - 7 दिवसांत माहिती हटवली जाईल.</p>],
  ["6. Cookies / Local storage", <p>Login ठेवण्यासाठी तुमच्या browser मध्ये एक सुरक्षित token साठवला जातो. Logout केल्यावर तो काढला जातो.</p>],
  ["7. बदल · Changes", <p>हे धोरण वेळोवेळी बदलू शकते. मोठे बदल वेबसाइटवर जाहीर केले जातील.</p>],
];

export default function Privacy() {
  return <LegalPage title="Privacy Policy · गोपनीयता धोरण" updated="June 2026" sections={S} testId="privacy-page" />;
}
